import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent } from '@groundworks/ngx-groundworks-ui';
import { DateService } from '../../services/date.service';

@Component({
  selector: 'app-date-range-selector',
  imports: [DatePickerComponent, ReactiveFormsModule, CommonModule],
  templateUrl: './date-range-selector.component.html',
})
export class DateRangeSelectorComponent {
  private readonly dateService = inject(DateService);

  @Output() dateRangeChanged = new EventEmitter<{ startDate?: Date; endDate?: Date }>();

  showDatePicker = false;
  minDate = this.dateService.addYears(new Date(), -10);
  dateRangeData = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
  });

  toggleDatePicker(): void {
    this.showDatePicker = !this.showDatePicker;
  }

  handleFromDate(date: Date | null): void {
    this.dateRangeData.patchValue({ startDate: date }, { emitEvent: false });
  }

  handleToDate(date: Date | null): void {
    this.dateRangeData.patchValue({ endDate: date }, { emitEvent: false });
    if (date) {
      this.showDatePicker = false;
    }
  }

  clearDateRange(): void {
    this.dateRangeData.patchValue({ startDate: null, endDate: null }, { emitEvent: false });
  }

  closeDatePicker(): void {
    this.showDatePicker = false;
  }

  getDateRangeDisplay(): string {
    const startDate = this.dateRangeData.value.startDate;
    const endDate = this.dateRangeData.value.endDate;

    if (startDate && endDate) {
      const start = this.dateService.formatDateShort(startDate);
      const end = this.dateService.formatDateShort(endDate);
      return `${start} - ${end}`;
    } else if (startDate) {
      return this.dateService.formatDateShort(startDate);
    }
    return '';
  }

  get dateRange(): { startDate?: Date; endDate?: Date } {
    return {
      startDate: this.dateRangeData.value.startDate ?? undefined,
      endDate: this.dateRangeData.value.endDate ?? undefined,
    };
  }
}

